import React, { memo } from 'react'
import map from 'ramda/src/map'
import identity from 'ramda/src/identity'
import withStyles from '@material-ui/core/styles/withStyles'
import Slider from 'root/src/client/web/base/Slider'
import { BrandsSliderItem } from 'root/src/client/web/list/listItemComponents/BrandsSliderItem'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import { SliderCardsListStyle } from './style'

const BrandsList = memo(({
	classes, pageContent: { list }, isMobileRes, scrollItemBreakpoints, sliderWidth,
}) => {
	const [width] = useWindowSize()
	const renderSliderItem = () => identity
	return (
		<div className={classes.root}>
			<div className={classes.sliderWrapper}>
				<Slider
					dashes
					infinite
					autoScroll
					isMobileRes={isMobileRes}
					sliderWidth={sliderWidth(width)}
					sliderItems={list}
					showItems={scrollItemBreakpoints(width)}
					renderSliderItem={renderSliderItem}
					childrenLength={8}
				>
					{map(props => (
						<BrandsSliderItem
							{...props}
						/>
					), list)}
				</Slider>
			</div>
		</div>
	)
})

export default withStyles(SliderCardsListStyle, { name: 'MuiBrandsSlider' })(BrandsList)
